<div>
	<div class="activity-overview-header">
		<h2 class="activity-overview-title">{{ 'activity-overview' | translate }}</h2>
		@if (selectedService.getGroup().hasReviewerRole(true)) {
			<button
				type="button"
				class="btn link-btn edit-btn"
				(click)="editActivity()">
					{{ 'activity-editor-panel-header_edit' | translate}}
			</button>
			<button
				type="button"
				class="edit-icon ficon-app-edit icon-btn"
				(click)="editActivity()">
			</button>
		}
	</div>
	<activity-info
		[activity]="activity"
		[viewFrom]="viewFrom.ACTIVITY_OVERVIEW"
		[hideNumOfAttempts]="true"
		[hideTimeLimit]="true"
		[hidePoints]="true"
		[hideInstructions]="true"
		[hideSourceMedia]="true"
		[isOnDashboard]="true">
	</activity-info>
</div>
